
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/power-delivery",
      function () {
        return require("private-next-pages/expertise/power-delivery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/power-delivery"])
      });
    }
  